export default [
  { 
    'fd': 1,
    'index': 1,
    'bid': 4,
    'title': '奔驰',
    'img': '//img.pcauto.com.cn/images/upload/upc/tx/auto5/2107/12/c2/271160602_1626059186509.png'
  },
  {
    'fd': 1,
    'index': 2,
    'bid': 20,
    'title': '宝马',
    'img': '//img.pcauto.com.cn/images/upload/upc/tx/auto5/2003/04/c17/195548234_1583331887620.jpg'
  },
  {
    'fd': 3,
    'index': 0,
    'bid': 2,
    'title': '大众',
    'img': '//img.pcauto.com.cn/images/upload/upc/tx/auto5/1909/11/c31/168530549_1568185133427.jpg'
  },
  {
    'fd': 4,
    'index': 0,
    'bid': 10,
    'title': '丰田',
    'img': '//img.pcauto.com.cn/images/upload/upc/tx/auto5/2205/24/c33/314387126_1653376864876.png'
  },
  {
    'fd': 1,
    'index': 0,
    'bid': 3,
    'title': '本田',
    'img': '//img.pcauto.com.cn/images/upload/upc/tx/auto5/1901/30/c3/130485946_1548828441913_96x96.jpg'
  },
  {
    'fd': 4,
    'index': 1,
    'bid': 21,
    'title': '福特',
    'img': '//img0.pcauto.com.cn/pcauto/1208/06/2064925_58-Ford.jpg'
  },
  {
    'fd': 1,
    'index': 4,
    'bid': 7,
    'title': '别克',
    'img': '//img.pcauto.com.cn/images/upload/upc/tx/auto5/1904/22/c41/143710663_1555916939625.jpg'
  },
  {
    'fd': 16,
    'index': 0,
    'bid': 15,
    'title': '日产',
    'img': '//img.pcauto.com.cn/images/upload/upc/tx/auto5/2009/25/c0/232366114_1600995796639.png'
  },
  {
    'fd': 21,
    'index': 0,
    'bid': 34,
    'title': '现代',
    'img': '//img.pcauto.com.cn/images/upload/upc/tx/auto5/2007/23/c43/222055193_1595491862474.jpg'
  },
  {
    'fd': 1,
    'index': 3,
    'bid': 107,
    'title': '比亚迪',
    'img': '//img.pcauto.com.cn/images/upload/upc/tx/auto5/2101/04/c3/248437836_1609733774054.png'
  }
]